import React from "react";
import { useTopTraders } from "../../../hooks"; // Adjust the import path
import {
  Pagination,
  Skeleton,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { transformToBTC } from "../../../utils/helpers";
import { useBitcoinPrice } from '../../../state/context/bitcoin.context'; // Adjust path if needed

const TraderRow = ({ trader }) => {
  const { price: btcPrice } = useBitcoinPrice();

  const profitUSD = btcPrice ? btcPrice * trader.totalNetProfit / 1e11 : null;
  const navigate = useNavigate();
  return (<TableRow
    key={trader._id}
    style={{ cursor: "pointer", padding: "0 1px" }}
    sx={{
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      },
    }}
    onClick={() =>
      window.open(`/users/${ trader.user }`)
    }
  >
    <TableCell sx={{ py: 0.5, px: 1, fontSize: '0.65rem', fontWeight: 'bold' }}>
      <Typography variant="body2" component="span" sx={{ fontSize: '0.65rem', fontWeight: 'bold' }}>
        {trader.user.slice(0, 3)}...{trader.user.slice(-3)}
      </Typography>
    </TableCell>
    <TableCell align="right" sx={{ py: 0.5, px: 1 }}>
      <Stack direction="column" spacing={0.2} alignItems="flex-end">
        <Typography variant="body2" sx={{ fontSize: '0.65rem', fontWeight: 'bold' }}>
          {transformToBTC(trader.totalNetProfit)}
        </Typography>
        {
          profitUSD && (
            <Typography variant="caption" sx={{
              color: "rgba(255,255,255,0.7)",
              fontSize: '0.6rem',
              fontWeight: 'bold'
            }}>
              ${profitUSD >= 1000 ? (profitUSD / 1000).toFixed(1) + 'K' : profitUSD.toFixed(0)}
            </Typography>
          )
        }
      </Stack>
    </TableCell>
    <TableCell align="right" sx={{ py: 0.5, px: 1, fontSize: '0.65rem', fontWeight: 'bold' }}>
      {trader.tokens.length}
    </TableCell>
    <TableCell align="right" sx={{ py: 0.5, px: 1, fontSize: '0.65rem', fontWeight: 'bold' }}>
      {trader.totalTrades}
    </TableCell>
  </TableRow>);
};
const TopTradersComponent = ({ selectedTimeOffset }) => {
  const { t } = useTranslation();

  const { data, loading, error, page, setPage, hasNextPage } = useTopTraders(
    selectedTimeOffset,
    10
  );

  if (loading)
    return (
      <Skeleton
        sx={{ flexGrow: 1 }}
        variant="rectangular"
        // width={210}
        // height={118}
        style={{ width: "100%", height: 300 }}
      />
    );
  if (error)
    return (
      <Typography color="error" align="center">
        {t('common.error')}: {error?.message}
      </Typography>
    );

  return (
    <Box sx={{ width: "100%", mx: "auto", overflow: "hidden", flexGrow: 1, display: "flex", flexDirection: "column" }}>
      {data.length === 0 ? (
        <Typography align="center">{t('common.noDataAvailable')}</Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ background: "black", py: 0.5, px: 1, fontSize: '0.7rem', minWidth: 'auto' }}>
                  <strong>{t('user.user')}</strong>
                </TableCell>
                <TableCell sx={{ background: "black", py: 0.5, px: 1, fontSize: '0.7rem', minWidth: 'auto' }} align="right">
                  <strong>{t('user.profitLoss')}</strong>
                </TableCell>
                <TableCell sx={{ background: "black", py: 0.5, px: 1, fontSize: '0.7rem', minWidth: 'auto' }} align="right">
                  <strong># {t('token.tokens')}</strong>
                </TableCell>
                <TableCell sx={{ background: "black", py: 0.5, px: 1, fontSize: '0.7rem', minWidth: 'auto' }} align="right">
                  <strong># {t('user.trades')}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((trader) => (
                <TraderRow key={trader._id} trader={trader} />

              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Pagination Controls */}
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
          count={hasNextPage ? page + 1 : page} // Assume one extra page exists
          page={page}
          onChange={(event, value) => setPage(value)}
          color="primary"
          size="small"
        />
      </Box>
    </Box>
  );
};

export default TopTradersComponent;
